import 'src/components/shared/CopyLink.css'
import { CopyText } from 'src/components/shared/CopyText'

type Props = {
  copyText: string
  text: string
  url: string
  className?: string
}

export const CopyLink: React.FC<Props> = ({
                                            copyText,
                                            text,
                                            url,
                                            className,
                                          }) => {
  return (
    <CopyText
      copyText={copyText}
      text={
        <a href={url} className={`link ${className || ''}`} target="_blank" rel="noreferrer">{text}</a>
      }
    />
  )
}
